import { token } from '@cp/shared/di';
import { CatalogItemViewService } from './model';

export const AUTH_FEATURE = token<() => Promise<unknown>>('catalogItem/AUTH_FEATURE');
export const CATALOG_ITEM_VIEW_SERVICE = token<CatalogItemViewService>('catalogItemView/SERVICE');
